var _style, _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBronnenLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 29.92 29.92",
    style: {
      enableBackground: "new 0 0 29.92 29.92"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#404040;}\n\t.st1{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 14.96,
    cy: 14.96,
    r: 14.96
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.82,11.75V8.11h-5.35c-0.36,0-0.64,0.29-0.64,0.64v12.42c0,0.36,0.29,0.64,0.64,0.64h8.99 c0.36,0,0.64-0.29,0.64-0.64v-8.78h-3.64C16.1,12.39,15.82,12.1,15.82,11.75z M17.53,18.06c0,0.18-0.14,0.32-0.32,0.32h-4.5 c-0.18,0-0.32-0.14-0.32-0.32v-0.21c0-0.18,0.14-0.32,0.32-0.32h4.5c0.18,0,0.32,0.14,0.32,0.32V18.06z M17.53,16.35 c0,0.18-0.14,0.32-0.32,0.32h-4.5c-0.18,0-0.32-0.14-0.32-0.32v-0.21c0-0.18,0.14-0.32,0.32-0.32h4.5c0.18,0,0.32,0.14,0.32,0.32 V16.35z M17.53,14.42v0.21c0,0.18-0.14,0.32-0.32,0.32h-4.5c-0.18,0-0.32-0.14-0.32-0.32v-0.21c0-0.18,0.14-0.32,0.32-0.32h4.5 C17.38,14.1,17.53,14.25,17.53,14.42z M20.1,11.37v0.16h-3.43V8.11h0.16c0.17,0,0.33,0.07,0.46,0.19l2.62,2.62 C20.03,11.04,20.1,11.2,20.1,11.37z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBronnenLogo);
export default __webpack_public_path__ + "static/media/bronnen-logo.3ac9f7987b67f737dc3f92f56c8b81b1.svg";
export { ForwardRef as ReactComponent };